import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../store/authSlice';
import logo from '../assets/logo.jpeg';

const AdminLogin = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated, user } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isAuthenticated && user) {
            if (user.role === 'super_admin') {
                navigate('/admin/dashboard', { replace: true });
            }
        }
    }, [isAuthenticated, user, navigate]);

    const onAdminFinish = async (values) => {
        setLoading(true);
        try {
            await dispatch(loginUser({
                email: values.email,
                password: values.password,
                role: 'super_admin'
            })).unwrap();

            message.success('Login successful');
            navigate('/admin/dashboard');
        } catch (err) {
            message.error(err || 'Invalid credentials');
        }
        setLoading(false);
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            position: 'relative',
            padding: '24px 0',
            overflowX: 'hidden'
        }}>
            {/* Decorative blobs */}
            <div style={{ position: 'absolute', top: -100, left: -100, width: 400, height: 400, background: '#2563eb', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>
            <div style={{ position: 'absolute', bottom: -100, right: -100, width: 400, height: 400, background: '#8b5cf6', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>

            <Card
                style={{ width: 400, border: '1px solid rgba(255,255,255,0.1)' }}
                styles={{ body: { padding: '32px' } }}
            >
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ height: 56, width: 'auto', objectFit: 'contain', marginBottom: 12 }}
                    />
                    <h1 style={{ color: '#fff', margin: 0, fontSize: 24 }}>
                        SUPER ADMIN
                    </h1>
                    <p style={{ color: '#94a3b8', marginTop: 8 }}>Restricted Access Area</p>
                </div>

                <Form
                    name="admin_login"
                    onFinish={onAdminFinish}
                    layout="vertical"
                >
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ required: true, message: 'Please input your email!' }]}
                    >
                        <Input placeholder="admin@admin.com" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password placeholder="admin123" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={loading}>
                            Login securely
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default AdminLogin;
